/* 自定义工具函数 */
// 导入数字精度计算
// const Decimal = require('decimal');
// const basics = require('./basics');
import basics from "./basics";

const util = {
  // 主网和测试网的倒计时数据, 主网=86400, 测试网=600;
  // 如:
  myTime: '86400',
  // 可撤资倒计时, 主网=30分钟, 测试网=90天;
  myTime2: '',

  // 加减乘除
  // 参数: 数字,字符串,16进制都可以(需要加0x前缀), 科学计数法(有bug,不建议使用); 建议统一使用十进制字符串进行计算;
  myAdd(a, b) {
    return basics.basAdd(a, b);
  },
  mySub(a, b) {
    return basics.basSub(a, b);
  },
  myMul(a, b) {
    return basics.basMul(a, b);
  },
  myDiv(a, b) {
    return basics.basDiv(a, b);
  },
  myGte(a, b) {
    return basics.basGte(a, b);
  },
  myGt(a, b) {
    return basics.basGt(a, b);
  },
  myEq(a, b) {
    return basics.basEq(a, b);
  },
  myLt(a, b) {
    return basics.basLt(a, b);
  },
  myLte(a, b) {
    return basics.basLte(a, b);
  },

	//  地址缩减
	addressCurtail(address) {
    if(!address) {
      return ''
    }
		// 0-3(3个), 倒数4(4个);
		let a1 = address.slice(0, 3);
		let a2 = address.slice(-4);
		return a1 + '...' + a2;
	},

	// 如果是T9y...uWwb代表410..地址, 替换成000...0000
	addressReplace(address) {
		if(address === 'T9y...uWwb') {
			return '000...0000';
		}else {
			return address;
		}
	},

	// 常用16进制->10进制->除6位->保留小数点3位
	hexTo10To6number3(number) {
		return this.numberFormat(this.div10e6(this.hexToDec(number)));
	},

	// 常用16进制->10进制->除18位->保留小数点3位
	hexTo10To18number3(number) {
		return this.numberFormat(this.div10e18(this.hexToDec(number)));
	},

  // 保留小数点后3位; 向下取整
  // 参数1: 数字字符串, 不能是科学计数法
  // 参数2: 数字, 保留小数的位数, 不写默认保存全部小数位
  // 返回值: 字符串
	numberFormat(str) {
    str = str.toString();
    const N = 3;
    if(str === '0') {
      return '0'
    }else if(/[\.]/.test(str)){
      let arr = str.split('.');
      if(arr[1].length >= N+1) {
        return arr[0] + '.' + arr[1].slice(0, N);
      }else {
        return arr[0] + '.' + arr[1].slice(0, arr[1].length);
      }
    }else {
      return str;
    }
	},
	numberFormat2(str) {
    str = str.toString();
    const N = 6;
    if(str === '0') {
      return '0'
    }else if(/[\.]/.test(str)){
      let arr = str.split('.');
      if(arr[1].length >= N+1) {
        return arr[0] + '.' + arr[1].slice(0, N);
      }else {
        return arr[0] + '.' + arr[1].slice(0, arr[1].length);
      }
    }else {
      return str;
    }
	},

	// usdt精度 10**6;
	mul10e6(str) {
    str = str.toString();
    if (str === '0') {
      return '0';
    }
    let zero = '1000000';
    return this.myMul(str, zero);
	},
	// ticket精度 10**18;
	mul10e18(str) {
    str = str.toString();
    if (str === '0') {
      return '0';
    }
    let zero = '1000000000000000000';
    return this.myMul(str, zero);
	},
	div10e6(str) {
    str = str.toString();
    if (str === '0') {
      return '0';
    }
    let zero = '1000000';
    return this.myDiv(str, zero);
	},
	div10e18(str) {
    str = str.toString();
    if (str === '0') {
      return '0';
    }
    let zero = '1000000000000000000';
    return this.myDiv(str, zero);
	},

	// 16进制转10进制
  // 参数: 字符串
  // 返回值: 字符串
	hexToDec(str) {
    str = str.toString();
    let numDec = parseInt(str, 16);
    return numDec+'';
	},

	// 格式化日倒计时
	dayFormat(time) {
		let date;
		if (time <= 0 || time > 86400) {
			date = {
				h: '00',
				m: '00',
				s: '00',
			}
		} else {
			date = {
				h: Math.floor(time / (60 * 60) % 24) < 10 ? '0' + Math.floor(time / (60 * 60) % 24) : Math.floor(time / (60 * 60) %
					24),
				m: Math.floor((time / 60) % 60) < 10 ? '0' + Math.floor((time / 60) % 60) : Math.floor((time / 60) % 60),
				s: Math.floor(time % 60) < 10 ? '0' + Math.floor(time % 60) : Math.floor(time % 60)
			}
		}
		return date;
	},
	// 格式化周倒计时
	weekFormat(time) {
		let date;
		if (time <= 0 || time > 2592000) {
			date = {
				d: '00',
				h: '00',
				m: '00',
				s: '00',
			}
		} else {
			date = {
				d: Math.floor(time / (60 * 60 * 24) % 30) < 10 ? '0' + Math.floor(time / (60 * 60 * 24) % 30) : Math.floor(time /
					(60 * 60 * 24) % 30),
				h: Math.floor(time / (60 * 60) % 24) < 10 ? '0' + Math.floor(time / (60 * 60) % 24) : Math.floor(time / (60 * 60) %
					24),
				m: Math.floor((time / 60) % 60) < 10 ? '0' + Math.floor((time / 60) % 60) : Math.floor((time / 60) % 60),
				s: Math.floor(time % 60) < 10 ? '0' + Math.floor(time % 60) : Math.floor(time % 60)
			}
		}
		return date;
	},
	// 无止境的日倒计时, 很多很多天
	daysFormat(time) {
		let date;
		if (time <= 0) {
			date = {
				d: '00',
				h: '00',
				m: '00',
				s: '00',
			}
		} else {
			date = {
				d: Math.floor(time / (60 * 60 * 24) % 30) < 10 ? '0' + Math.floor(time / (60 * 60 * 24) % 30) : Math.floor(time /
					(60 * 60 * 24) % 30),
				h: Math.floor(time / (60 * 60) % 24) < 10 ? '0' + Math.floor(time / (60 * 60) % 24) : Math.floor(time / (60 * 60) %
					24),
				m: Math.floor((time / 60) % 60) < 10 ? '0' + Math.floor((time / 60) % 60) : Math.floor((time / 60) % 60),
				s: Math.floor(time % 60) < 10 ? '0' + Math.floor(time % 60) : Math.floor(time % 60)
			}
		}
		return date;
	},

	// 时间格式天:时:分:秒
	dayTime(time) {
		if (time <= 0) {
			return '00:00:00:00'
		}
		let d = Math.floor(time / (60 * 60 * 24) % 30) < 10 ? '0' + Math.floor(time / (60 * 60 * 24) % 30) : Math.floor(time /
			(60 * 60 * 24) % 30);
		let h = Math.floor(time / (60 * 60) % 24) < 10 ? '0' + Math.floor(time / (60 * 60) % 24) : Math.floor(time / (60 *
			60) % 24);
		let m = Math.floor((time / 60) % 60) < 10 ? '0' + Math.floor((time / 60) % 60) : Math.floor((time / 60) % 60);
		let s = Math.floor(time % 60) < 10 ? '0' + Math.floor(time % 60) : Math.floor(time % 60);
		return d + ':' + h + ':' + m + ':' + s;
	},
	dayTime2(time) {
		if (time <= 0) {
			return '00:00:00:00'
		}
		let d = Math.floor(time / (60 * 60 * 24)) < 10 ? '0' + Math.floor(time / (60 * 60 * 24)) : Math.floor(time /
			(60 * 60 * 24));
		let h = Math.floor(time / (60 * 60) % 24) < 10 ? '0' + Math.floor(time / (60 * 60) % 24) : Math.floor(time / (60 *
			60) % 24);
		let m = Math.floor((time / 60) % 60) < 10 ? '0' + Math.floor((time / 60) % 60) : Math.floor((time / 60) % 60);
		let s = Math.floor(time % 60) < 10 ? '0' + Math.floor(time % 60) : Math.floor(time % 60);
		return d + ':' + h + ':' + m + ':' + s;
	},
	// 时间格式时:分:秒
	hoursTime(time) {
		if (time <= 0) {
			return '00:00:00'
		}
		let h = Math.floor(time / (60 * 60) % 24) < 10 ? '0' + Math.floor(time / (60 * 60) % 24) : Math.floor(time / (60 *
			60) % 24);
		let m = Math.floor((time / 60) % 60) < 10 ? '0' + Math.floor((time / 60) % 60) : Math.floor((time / 60) % 60);
		let s = Math.floor(time % 60) < 10 ? '0' + Math.floor(time % 60) : Math.floor(time % 60);
		return h + ':' + m + ':' + s;
	}

};

export default util;



// WEBPACK FOOTER //
// ./src/common/util.js